module.exports = __webpack_public_path__ + "img/全息互动@2x.d7be9eea.png";